module.exports = __webpack_public_path__ + "img/8.ae41b6e7.jpg";